import { LayoutDashboard, User, FileText, Bookmark } from "lucide-react";

export const CANDIDATE_NAV = [
  { to: "/candidate/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "cnav-dashboard" },
  { to: "/candidate/profile", label: "My Profile", icon: User, testid: "cnav-profile" },
  { to: "/candidate/applications", label: "Applications", icon: FileText, testid: "cnav-applications" },
  { to: "/candidate/saved-jobs", label: "Saved Jobs", icon: Bookmark, testid: "cnav-saved" },
];
